"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStaticKey = exports.isEntityPropertyCondition = exports.isOperation = exports.isObjectOrArray = exports.isObject = exports.Instruction = exports.SUPPORTED_OPERATIONS = exports.NOT_OPERATION = exports.OR_OPERATION = exports.AND_OPERATION = void 0;
var types_1 = require("./types");
exports.AND_OPERATION = 'and';
exports.OR_OPERATION = 'or';
exports.NOT_OPERATION = 'not';
exports.SUPPORTED_OPERATIONS = [exports.AND_OPERATION, exports.OR_OPERATION, exports.NOT_OPERATION];
var Instruction;
(function (Instruction) {
    Instruction["Skip"] = "skip";
    Instruction["NeedData"] = "need-data";
    Instruction["Continue"] = "continue";
})(Instruction = exports.Instruction || (exports.Instruction = {}));
exports.isObject = function (x) { return Object.prototype.toString.call(x) === '[object Object]'; };
exports.isObjectOrArray = function (x) { return exports.isObject(x) || Array.isArray(x); };
exports.isOperation = function (key) { return exports.SUPPORTED_OPERATIONS.includes(key); };
exports.isEntityPropertyCondition = function (key) {
    return Object.values(types_1.PropertyConditionType).includes(key);
};
exports.isStaticKey = function (key) { return !exports.isOperation(key) && !exports.isEntityPropertyCondition(key); };
